<template lang="pug">
  el-dialog(
    :title="courseName"
    :visible="show"
    width="90%"
    custom-class="metrics-dialog"
    @close="$emit('update:show', false)"
  )
    .dialog-header-content
      .controls(:class="$style.controls")
        el-select(
          :class="$style.metricSelect"
          v-model="selectedType"
          size="small"
          @change="handleTypeChange"
        )
          el-option(
            v-for="option in metrics"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          )
        el-select(
          :class="$style.metricSelect"
          v-model="selectedPeriod"
          size="small"
          @change="handlePeriodChange"
        )
          el-option(
            v-for="option in periodOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          )
    line-chart(
      v-loading="loading"
      element-loading-text="Loading metrics..."
      :values="data.values"
      :labels="data.labels"
      :title="title"
    )
</template>

<script>
  import { mapState } from 'vuex'
  import capitalize from 'lodash/capitalize'
  import LineChart from '@/masteradmin/components/LineChart'
  import { ACTION_GET_METRICS } from '@/masteradmin/store/actions'
  import { MUTATION_SET_METRICS_TYPE, MUTATION_SET_METRICS_PERIOD } from '@/masteradmin/store/mutations'
  import { METRICS_PERIOD } from 'globalUtils/constants'
  import METRICS_LABELS from './constants'

  export default {
    components: {
      LineChart,
    },

    props: {
      show: {
        type: Boolean,
        default: false,
      },
      code: {
        type: String,
      },
    },

    data() {
      return {
        title: '',
        selectedPeriod: this.period,
        selectedType: this.type,
        periodOptions: [
          { label: 'Past Month', value: METRICS_PERIOD.MONTH },
          { label: 'Past Year', value: METRICS_PERIOD.YEAR },
        ],
      }
    },

    computed: {
      ...mapState({
        loading: state => state.metrics.loading,
        period: state => state.metrics.period,
        type: state => state.metrics.type,
        data: state => state.metrics.data,
      }),
      courseName() {
        return this.code ? this.code.toUpperCase() : ''
      },
      metrics() {
        return METRICS_LABELS
      },
    },

    created() {
      this.selectedType = this.type
      this.selectedPeriod = this.period
      this.fetchMetricsData(this.type, this.period)
    },

    methods: {
      handlePeriodChange(value) {
        this.$store.commit(MUTATION_SET_METRICS_PERIOD, value)
        this.fetchMetricsData(this.type, value)
      },
      handleTypeChange(value) {
        this.$store.commit(MUTATION_SET_METRICS_TYPE, value)
        this.fetchMetricsData(value, this.period)
      },
      fetchMetricsData(type, period) {
        this.title = `${capitalize(type)}s metric for the past ${period}`
        this.$store.dispatch(ACTION_GET_METRICS, { code: this.code, type, period })
      },

    },
  }
</script>

<style module>
  .controls {
    position: absolute;
    left: 20px;
    top: 20px;
    display: flex;
    gap: 8px; 
  }

  .metricSelect {
    width: 120px;
  }
</style>

<style>
  .metrics-dialog .el-dialog__header {
    text-align: center;
    padding: 32px 20px 0px;
    position: relative;
  }

  .metrics-dialog .el-dialog__body {
    text-align: center;
    padding: 0px 20px 32px;
  }

  .metrics-dialog .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .metrics-dialog .el-select .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// client/masteradmin/components/MetricsModal/MetricsModal.vue